











































import { defineComponent, PropType, computed, ref } from '@nuxtjs/composition-api';
import AppImage from '~/components/partials/App/AppImage.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import { url } from '~/utils';
import { CommonProducingArea } from '~/types/common';
import { BooleanLike } from '~/enums';

type FontSize = 'xs' | 'sm' | 'base';
type TextBlackColors = '60' | '88';

export default defineComponent({
  components: {
    AppImage,
    AppLink,
  },
  props: {
    producingArea: {
      type: Object as PropType<CommonProducingArea>,
      required: true,
    },
    hasLink: {
      type: Boolean,
      required: false,
    },
    fontSize: {
      type: String as PropType<FontSize>,
      default: 'sm',
    },
    textBlackColor: {
      type: String as PropType<TextBlackColors>,
      default: '88',
    },
    isClamped: {
      type: Boolean,
      default: false,
    },
    isEnglish: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const isDefault = ref(false);

    const imgPath = computed(() => {
      if (isDefault.value) {
        return '/images/flags/icon_flag-others.png';
      } else {
        return `/images/flags/icon_flag-${props.producingArea.code_id}.png`;
      }
    });

    const altText = computed(() => props.producingArea.areas?.[0]?.name);

    const fontSizeClass = computed(() => `text-${props.fontSize}`);

    const textColorClass = computed(() => `text-Black${props.textBlackColor}`);

    const setDefaultImg = () => {
      isDefault.value = true;
    };

    return {
      url,
      imgPath,
      fontSizeClass,
      textColorClass,
      BooleanLike,
      altText,
      setDefaultImg,
    };
  },
});
